"use client";

/**
 * @deprecated Prefer `@repo/ui/components/sonner`.
 * Backward-compatible re-export for one release.
 */
export {
	Toaster,
	toast,
	toastProposedAction,
	toastLiveProgress,
	dismissToast,
	TOASTER_PLACEMENT_CLASSNAME,
} from "./sonner";
